<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-cascader
        popper-class="area"
        ref="component"
        :style="inputStyle"
        :disabled="!isedite"
        v-model="val"
        :options="arealist()"
        @change="handleBlur"
        :clearable="clearable"
        v-if="true"
      ></el-cascader>

      <el-input
        :disabled="!isedite"
        :style="inputStyle"
        :placeholder="placeholder"
        v-model="val"
        ref="component"
        @focus="handelfocus"
        v-else
        suffix-icon="el-icon-arrow-right"
      />
    </el-tooltip>
    <van-popup v-model="show" round position="bottom" v-if="false">
      <van-cascader
        :field-names="{ text: 'label' }"
        v-model="cascaderValue"
        title="请选择地区"
        :options="arealist()"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
import * as storage from '@/utils/storage'
import * as constants from '@/constants'
import Validator from '../../utils/validator.js'
import _ from 'lodash'
import { location } from '../../utils/tool'

export default {
  name: 'jtDistrict',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },

    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      val: this.value.split(','),
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
      options: location(),
      clearable: true,
      show: false,
      cascaderValue: '',
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    arealist() {
      let arr = location()
      let { gameData } = storage.getItem(constants.GLOBAL_CONFIG)
      if (gameData['增加区域']) {
        gameData['增加区域'].forEach((item) => {
          let obj = arr.find((i) => i.value == item.value)
          if (obj) {
            let obj1 = obj.children.find(
              (i) => i.value == item.children[0].value
            )
            if (obj1) {
              obj1.children = obj1.children.concat(item.children[0].children)
            } else {
              obj.children = obj.children.concat(item.children)
            }
          }else{
            arr.push(item)
          }
        })
      }
      return arr
    },

    handelfocus() {
      if (this.value) {
        let arr = this.value.split(',')
        let last = _.last(arr)
        this.cascaderValue = last
      }
      this.show = true
    },

    onFinish({ value, selectedOptions }) {
      this.show = false
      this.val = selectedOptions.map((option) => option.label).join(',')
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      try {
        this.hasFiredEnterEventHandler = true
        this.$emit('enter')
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    handleBlur() {
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    _validate(value) {
      const min = this.minLength
      const max = this.maxLength
      const minErrMsg = this.$t('input.MIN_LENGTH', { min })
      const maxErrMsg = this.$t('input.MAX_LENGTH', { max })

      Validator.isLength(value, { min }, minErrMsg)
      Validator.isLength(value, { max }, maxErrMsg)
    },
    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        this.val = value
      }
      this.$emit('datas', null, value)
    },
  },
}
</script>

<style lang="stylus">
.area {
  .el-cascader-panel {
    height: 250px;
  }
}

@media screen and (max-width: 768px) {
  .area {
    width: 100vw;
    max-width: 600px;
    overflow-x: auto;

    .el-cascader-panel {
      // width: 460px;
      display: block;
      height: auto;
      overflow: hidden;
    }

    .el-cascader-menu {
      min-width: 0;
      width: 33%;
      float: left;
      max-height: 250px;
      overflow-y: auto;

      .el-cascader-node {
        padding: 0 15px;
      }
    }
  }
}
</style>
